import { render, staticRenderFns } from "./PracticeExamSettings.vue?vue&type=template&id=ce38e700&scoped=true"
import script from "./PracticeExamSettings.vue?vue&type=script&lang=js"
export * from "./PracticeExamSettings.vue?vue&type=script&lang=js"
import style0 from "./PracticeExamSettings.vue?vue&type=style&index=0&id=ce38e700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce38e700",
  null
  
)

export default component.exports